export default {
  common: {
    welcome: '欢迎',
    login: '登录',
    logout: '登出',
    register: '注册',
    email: '邮箱',
    password: '密码',
    confirmPassword: '确认密码',
    submit: '提交',
    cancel: '取消',
    save: '保存',
    delete: '删除',
    edit: '编辑',
    search: '搜索',
    loading: '加载中...',
    error: '错误',
    success: '成功',
    close: '关闭',
    back: '返回',
    next: '下一步',
    previous: '上一步',
    yes: '是',
    no: '否',
    ok: '确定',
  },
  auth: {
    signIn: '登录',
    signUp: '注册',
    signOut: '登出',
    forgotPassword: '忘记密码？',
    resetPassword: '重置密码',
    changePassword: '修改密码',
    emailAddress: '邮箱地址',
    enterEmail: '输入您的邮箱',
    enterPassword: '输入您的密码',
    rememberMe: '记住我',
    dontHaveAccount: '还没有账号？',
    alreadyHaveAccount: '已有账号？',
    createAccount: '创建账号',
    passwordRequirements: '密码至少需要8个字符',
    accountCreated: '账号创建成功',
    loginSuccess: '登录成功',
    loginFailed: '登录失败',
    invalidCredentials: '邮箱或密码无效',
    emailRequired: '邮箱是必填项',
    passwordRequired: '密码是必填项',
    passwordMismatch: '密码不匹配',
  },
  validation: {
    required: '此字段为必填项',
    invalidEmail: '邮箱地址无效',
    minLength: '至少需要{{count}}个字符',
    maxLength: '最多只能{{count}}个字符',
    passwordTooShort: '密码至少需要{{count}}个字符',
    passwordTooWeak: '密码强度太弱',
    emailInUse: '邮箱已被使用',
    invalidFormat: '格式无效',
  },
  errors: {
    general: '出错了，请重试。',
    network: '网络错误，请检查您的连接。',
    notFound: '资源未找到',
    unauthorized: '您无权执行此操作',
    serverError: '服务器错误，请稍后重试。',
    timeout: '请求超时，请重试。',
  },
} as const
